import React, { useEffect } from "react";
import Cards from "../Cards";
import './index.scss';
import Course_1 from "../courseCards/course_1_cards";

const Dashboard = () => {

    return (
        <section>
            <div className="dashboard-main-container ">
                <div className="container">
                    <div className="dashboard-container">
                        <h3>Welcome to </h3>
                        <h1><span className="span-color">comdex</span> academia</h1>
                        <p className="home_main_paira">One-stop place to learn basic to advance topics about Crypto, DeFi, Commodities, Derivatives, and much more!
                            Complete the course and mint an amazing NFT of your completion certificate. </p>
                    </div>
                </div>
            </div>
            <Course_1 />

        </section>
    )
}

export default Dashboard;